function Introduction() {
    return (
        <div className=" bg-gray-100 h-96 flex justify-center flex-col px-5">
            <h1 className="text-6xl">
                <span className="hidden md:block">Justin Cheah Yun Fei</span>
                <span className="block md:hidden">Justin Cheah</span>
            </h1>
            <h2 className="text-3xl text-zinc-600">
                <span className="hidden md:block">Software Engineer | Computer Science at NUS</span>
                <span className="block md:hidden">Software Engineer | CS @ NUS</span>
            </h2>
        </div>
    );
}

export default Introduction;
